import { render, staticRenderFns } from "./PartnersBoard.vue?vue&type=template&id=2a42ab84&scoped=true&"
import script from "./PartnersBoard.vue?vue&type=script&lang=js&"
export * from "./PartnersBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a42ab84",
  null
  
)

export default component.exports